import { initializeApp } from "firebase/app";
import { getMessaging, onMessage } from "firebase/messaging";
// logo
import Logo from '../src/assets/salesblink-icon-only-logo.png';

const firebaseConfig = {
    apiKey: "AIzaSyD9yTHXP4MXbel2ZqH18PnU_KOPTHzQ85M",
    authDomain: "salesblink.firebaseapp.com",
    projectId: "salesblink",
    storageBucket: "salesblink.firebasestorage.app",
    messagingSenderId: "672501151861",
    appId: "1:672501151861:web:64321a73176fc5dab4a03c"
};

const app = initializeApp(firebaseConfig)

let messaging = null;

try {
    messaging = getMessaging(app);
} catch (e) {
    // Silently skip on unsupported browsers (Safari, Brave, Firefox Private, etc.)
}

export { messaging };

export const onMessageListener = () => {
    if (!messaging) return Promise.resolve(null);
    return new Promise((resolve) => {
        onMessage(messaging, (payload) => {
            const { title = "New Notification", body = "You have a new message.", actionUrl = "/" } = payload.data || {};
            const options = {
                body,
                icon: Logo
            }
            const notif = new Notification(title,options);
            notif.onclick = () => {
                window.open(actionUrl, '_blank');
            };
            resolve(payload);
        });
    }
    );
}
